import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: 'refresh.component.html',
  styles: [`
    
    .loader {      
      border: 16px solid #f3f3f3; /* Light grey */
      border-top: 16px solid #3498db; /* Blue */
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
      position: absolute;
      left: 45%;
      top: 42%;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class RefreshComponent implements OnInit {

  private navigateTo: string;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    this.navigateTo = this.route.snapshot.params['page'] || '/login';
        
    this.router.navigate(["/login"]);
    /*if (this.navigateTo === '/login') {         
      if (this.authService.getUser().idTipoAcesso === 1 || this.authService.getUser().idTipoAcesso === 2) {
        this.router.navigateByUrl('/student', { skipLocationChange: true })
        .then(() => {          
          this.router.navigate([atob(btoa('/student'))]);        
        });            
      } else if (this.authService.getUser().idTipoAcesso === 3 || this.authService.getUser().idTipoAcesso === 5) {

        this.router.navigateByUrl('/teacher', { skipLocationChange: true })
        .then(() => {          
          this.router.navigate([atob(btoa('/teacher'))]);
        });        
      }              
    } else {      
      this.router.navigate([atob(this.navigateTo)]);      
    } */   
  }

}
